import { render, staticRenderFns } from "./PartnerRegisterIcon.vue?vue&type=template&id=b8a2e362&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports